import { OptionsType } from "../modules/admin/Tabs/Online Casino/AddNewCasino";

export const formatDate = (dateString: string) => {
  const date = new Date(dateString);
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}`;
};

export const formatDateTime = (dateString: string) => {
  const date = new Date(dateString);
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");
  const hours = String(date.getHours()).padStart(2, "0");
  const minutes = String(date.getMinutes()).padStart(2, "0");
  const seconds = String(date.getSeconds()).padStart(2, "0");

  return `${year}-${month}-${day} - ${hours}:${minutes}:${seconds}`;
};

export const getCommaSeparatedString = (data: OptionsType[]) => {
  return data.map((item) => item.value).join(", ");
};

export const isSubstring = (parent: string, child: string) => {
  return parent.toLowerCase().includes(child.toLowerCase());
};

export const appendText = (baseText: string, textToAppend: string): string => {
  return (baseText + textToAppend) as string;
};
